import tableId from "./tables/id";
import tosAndPapId from "./tos-and-pap/id";

const id = {
	components: {
		table: {
			...tableId,
		},
		tos_and_pap: {
			...tosAndPapId,
		},
	},
};

export default id;
